// extracted by mini-css-extract-plugin
export default {"container":"user-guide_container__tMCzn"};